/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */
import ReducerShowcase from './reducer-showcase';

export default ReducerShowcase;



// WEBPACK FOOTER //
// ./src/reducers/showcase/index.js